import styled from "styled-components";
import { EditFilled } from "@ant-design/icons";
import { Button } from "antd";

interface SoaData {
  meetKppNumber?: string;
  meetGender?: string;
  meetAge?: string;
  meetOrgan?: string;
  meetDiagnosis?: string;
  meetOrganization?: string;
}

interface Props {
  soaData: SoaData | null;
  layout?: "row" | "col";
  hasEditAuth?: boolean;
  onEdit?: () => void;
}

const StRow = ({ label, value }: { label: string; value: any }) => {
  if (!value) return null;

  return (
    <div style={{ display: "contents" }}>
      <StInfoLabel>{label}</StInfoLabel>
      <StInfoValue>{value}</StInfoValue>
    </div>
  );
};

const SoaInfoPanel = ({ soaData, layout = "row", hasEditAuth = false, onEdit }: Props) => {
  const hasInfo = !!(soaData && (
    soaData.meetKppNumber ||
    soaData.meetGender ||
    soaData.meetAge ||
    soaData.meetOrgan ||
    soaData.meetDiagnosis ||
    soaData.meetOrganization
  ));

  // 기본 연구 정보 없어도 UI는 표시되도록
  if (!soaData) return null;

  const gridColumns =
    layout === "col"
      ? "8rem minmax(0, 1fr) 8rem minmax(0, 1fr)"
      : "8rem minmax(0, 1fr)";

  return (
    <>
      <InfoPanelSubTitleWrapper>
        <InfoPanelSubTitle>{`Case Conference`}</InfoPanelSubTitle>
        {hasEditAuth && onEdit && (
          <StEditButton
            type="default"
            size="small"
            icon={<EditFilled />}
            onClick={onEdit}
          >
            Edit conference data
          </StEditButton>
        )}
      </InfoPanelSubTitleWrapper>
      {hasInfo ? (
        <StSectionContent
          style={{
            display: "grid",
            gridTemplateColumns: gridColumns,
            rowGap: "10px",
          }}
        >
          <StRow label="KPP Number" value={soaData.meetKppNumber} />
          <StRow label="Gender" value={soaData.meetGender} />
          <StRow label="Age" value={soaData.meetAge} />
          <StRow label="Organ" value={soaData.meetOrgan} />
          <StRow label="Diagnosis" value={soaData.meetDiagnosis} />
          <StRow label="Organization" value={soaData.meetOrganization} />
        </StSectionContent>
      ) : (
        <EmptyDataMessage>
          No case conference data available. Click Edit to add information.
        </EmptyDataMessage>
      )}
    </>
  );
};

export default SoaInfoPanel;

const StSectionContent = styled.div`
  padding: 10px;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
`;

const StInfoLabel = styled.div`
  border-right: 1px solid gray;
  font-size: 1rem;
  font-weight: 600;
`;

const StInfoValue = styled.div`
  margin-left: 1rem;
  white-space: pre-wrap;
  word-break: break-word;
`;

const InfoPanelSubTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 9px 10px 2px;
`;

const InfoPanelSubTitle = styled.div`
  font-size: 0.8rem;
  font-weight: 600;
  color: #888;
  text-transform: uppercase;
`;

const StEditButton = styled(Button)`
  margin-top: 5px;
`;

const EmptyDataMessage = styled.div`
  padding: 20px 10px;
  text-align: center;
  color: #999;
  font-size: 0.9rem;
  font-style: italic;
`;
